import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { languageSelector } from '../../../../redux/features/language/languageSlice'
import apiService, { apiBaseUrl } from '../../../../utils/api/service'
import { endpoints } from '../../../../utils/api/endpoints'
import Layout from '../../Layout'
import Box from '../../../Shared/Box'
import Button from '../../../Shared/Form/Button'

const ViewListsPage = () => {
  const [supplierLists, setSupplierLists] = useState([])
  const { t } = useTranslation()
  const language = useSelector(languageSelector)

  useEffect(() => {
    const fetchAllSuppliers = async () => {
      const { fetchPromise } = apiService.fetchAllSuppliers()
      return await fetchPromise
    }

    const fetchAllSupplierLists = async (suppliers) => {
      const { fetchPromise } = apiService.fetchAllSupplierLists()
      let supplierLists = await fetchPromise

      // Add joinedIdAndName property to the supplier
      supplierLists = supplierLists.map(supplierList => {
        const supplier = suppliers.find(supplier => supplier.id === supplierList.supplierId)
        if (!supplier) {
          console.error(`Supplier not found. Supplier Id: ${supplierList.supplierId}`)
        } else {
          supplierList.supplierName = supplier.name
        }

        return supplierList
      })

      setSupplierLists(supplierLists)
    }

    (async () => {
      const suppliers = await fetchAllSuppliers()
      await fetchAllSupplierLists(suppliers)
    })()
  }, [])

  const onDownload = (e) => {
    e.preventDefault()
    const supplierId = e.target.parentElement.parentElement.id
    const fetchDownloadUrl = async () => {
      const { fetchPromise } = apiService.fetchDownloadToken(supplierId)
      const response = await fetchPromise
      return apiBaseUrl + endpoints.getDownload(response['token'])
    }

    (async () => {
      const downloadUrl = await fetchDownloadUrl()
      let a = document.createElement('a')
      a.href = downloadUrl
      a.download = ''
      document.body.appendChild(a)
      a.click()
      a.remove()
    })()
  }

  const supplierListsTable = (supplierLists) => supplierLists.map((supplierList) => {
    return (
      <tr id={supplierList.supplierId} key={supplierList.supplierId}>
        <td data-title={'Supplier id'}>{supplierList.supplierId}</td>
        <td data-title={'Supplier name'}>{supplierList.supplierName}</td>
        <td
          data-title={'Date'}>{new Date(Date.parse(supplierList.createdAt)).toLocaleDateString(language.isoCode, {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        })}</td>
        <td data-title={'Download'}>
          <Button classNames={'Button-small clearfix'} onClick={onDownload}>Download</Button>
        </td>
      </tr>
    )
  })

  return (
    <Layout>
      <div className="page view-lists-page">
        <Box>
          <h2>{t('VIEW_LISTS')}</h2>
          <h4>{t('VIEW_LISTS_SUBTEXT')}</h4>
          <div className="flex-table" style={{ flex: 1 }}>
            <div style={{ position: 'relative' }} className="table-responsive-vertical">
              <table className="table table-hover table-mc-light-blue Gradient">
                <thead>
                <tr>
                  <td>{t('SUPPLIER_ID')}</td>
                  <td>{t('SUPPLIER_NAME')}</td>
                  <td>{t('DATE')}</td>
                  <td>{t('ACTION')}</td>
                </tr>
                </thead>
                <tbody>
                {supplierLists && supplierListsTable(supplierLists)}
                </tbody>
              </table>
            </div>
          </div>
        </Box>
      </div>
    </Layout>
  )
}

export default ViewListsPage
